import type { ReactNode } from 'react';

export const symbol_udon: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-157 0-270.5-105T82-443q-2-15.1 8.44-26.05Q100.89-480 116-480h44v-293q0-11.05 8-19.53 8-8.47 19-10.47l666-74q11.45-2 19.23 6 7.77 8 7.77 19 0 10-6 16.5t-16 7.5l-448 50v87h445q10.83 0 17.92 7.12 7.08 7.11 7.08 18 0 10.88-7.08 17.88-7.09 7-17.92 7H410v161h434q14.89 0 24.95 11Q879-458 878-443q-14 153-127.5 258T480-80ZM210-480h50v-161h-50v161Zm0-211h50v-71l-50 5.68V-691Zm100 211h50v-161h-50v161Zm0-211h50v-82l-50 6v76ZM167-350h625q7-17 12.5-34.5T813-420H147q3 18 8 35.5t12 34.5Zm313 210q88 0 161-41t119-109H200q46 68 119 109t161 41Zm0-150Zm0-60Zm0 60v-60 60Z"
		/>
	</svg>
);
